import React from 'react';
import styled from 'styled-components';
import { SquareButton } from './Button';

const PrintButton = () => (
  <SquareButton
    aria-label="Print"
    kind="secondary"
    icon="print"
    onClick={() => {
      window.print();
    }}
  />
);

export default styled(PrintButton)``;
